import type { AnyAction } from "redux";
import {
    TOGGLE_OFF_COMPARE_DROPDOWN,
    TOGGLE_ON_COMPARE_DROPDOWN,
    TOGGLE_ON_MAIN_SITE_DROPDOWN,
    TOGGLE_ON_PERSISTENT_QUERY_BAR,
    SHOW_QUERY_BAR_TOOLTIP,
    HIDE_QUERY_BAR_TOOLTIP,
} from "app/action_types/website_analysis_action-types";

interface IQueryBarState {
    isCompareButtonOpen: boolean;
    isMainSiteDropdownOpen: boolean;
    isPersistent: boolean;
    tooltip: {
        isVisible: boolean;
        content: string;
    };
}

const initialState: IQueryBarState = {
    isCompareButtonOpen: false,
    isMainSiteDropdownOpen: false,
    isPersistent: false,
    tooltip: {
        isVisible: false,
        content: "",
    },
};

export function QueryBarReducer(state = initialState, action: AnyAction): IQueryBarState {
    switch (action.type) {
        case TOGGLE_ON_MAIN_SITE_DROPDOWN: {
            return {
                ...state,
                isMainSiteDropdownOpen: true,
            };
        }
        case TOGGLE_ON_COMPARE_DROPDOWN: {
            return {
                ...state,
                isCompareButtonOpen: true,
            };
        }
        case TOGGLE_OFF_COMPARE_DROPDOWN: {
            return {
                ...state,
                isCompareButtonOpen: false,
                isPersistent: false,
                isMainSiteDropdownOpen: false,
            };
        }
        case TOGGLE_ON_PERSISTENT_QUERY_BAR: {
            return {
                ...state,
                isCompareButtonOpen: true,
                isPersistent: true,
            };
        }
        case SHOW_QUERY_BAR_TOOLTIP: {
            return {
                ...state,
                tooltip: {
                    isVisible: true,
                    content: action.payload.content,
                },
            };
        }
        case HIDE_QUERY_BAR_TOOLTIP: {
            return {
                ...state,
                tooltip: {
                    isVisible: false,
                    content: "",
                },
            };
        }
        default:
            return state;
    }
}
